import { andVobFilter } from '@iotv/core-services';
import { EntityNetworkClassName, getChildEdgeTypeId } from '@iotv/datamodel-core';
import { TypeIcons } from '../../../Iconography';
import { AdjacentType } from '../../../types';
export const getCustomerEntityNetworkPath = ({ filters }) => {
    const apexQuery = {
        nodeFilter: andVobFilter(filters),
        renderTypeFolder: false,
        hideThisStep: false,
        stepQuery: {
            objectTypeId: EntityNetworkClassName,
            adjacencyType: AdjacentType.CHILD,
            edgeTypeId: getChildEdgeTypeId('Customer', 'EntityNetwork'),
        },
        endIcon: TypeIcons.EntityNetwork,
        nextSteps: [],
    };
    return apexQuery;
};
const customerEntityNetworkPath = getCustomerEntityNetworkPath({ filters: [] });
export { customerEntityNetworkPath };
